<template>
    <HeaderContent title="Cleaning"/>
    <ActionContent :cta="false" ctaText="Cleaning" @action="modal = !modal" :filterDate="false" @showFilter="modalFilter = !modalFilter"/>
    <CleaningStatistics title="Cleaning Statistics" :data="statistics" />
    <CleaningForm :modal="modal" @update:modal="modal = $event" />
    <CleaningFinish title="Cleaning Finish" :modalConfirm="modalTime" @update:modalConfirm="modalTime = $event">
        <template #body>
            <BForm>
                <BFormTextarea placeholder="Remarks"></BFormTextarea>
            </BForm>
        </template>
    </CleaningFinish>
    <CleaningDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>
</template>

<script>
import { ref } from "vue";
import { 
    BForm, 
    BFormTextarea 
} from "bootstrap-vue-next";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CleaningForm from "./CleaningForm.vue";
import CleaningFinish from "@/components/ModalDialog.vue";
import CleaningStatistics from "@/components/StatisticData.vue";
import CleaningDataTable from "@/components/DataTable.vue";
import iconToday from '../../../../public/icons/sun.svg';
import iconWeek from '../../../../public/icons/week.svg';

export default {
    name: 'CleaningIndex',
    components: {
        BForm,
        BFormTextarea,
        HeaderContent,
        ActionContent,
        CleaningFinish,
        CleaningStatistics,
        CleaningForm,
        CleaningDataTable,
    },
    setup(){
        const modal = ref(false)
        const modalTime = ref(false)
        const data = ref([
            {
                no_room: 'A3',
                type_room: 'Deluxe',
                date: '19/02/2025',
                start_time: '13:00',
                end_time: '-',
                duration: '00:00',
                done_by: 'Siti',
                remarks: 'lorem ipsum dolor sit amet',
                status_cleaning: 'start',
            },
            {
                no_room: 'A4',
                type_room: 'Super Deluxe',
                date: '19/02/2025',
                start_time: '13:00',
                end_time: '-',
                duration: '00:00',
                done_by: 'Udin',
                remarks: 'lorem ipsum dolor sit amet',
                status_cleaning: 'start',
            },
            {
                no_room: 'A2',
                type_room: 'Honeymoon',
                date: '19/02/2025',
                start_time: '13:00',
                end_time: '13:45',
                duration: '00:45',
                done_by: 'Deni',
                remarks: 'lorem ipsum dolor sit amet',
                status_cleaning: 'finish',
            },
            {
                no_room: 'A5',
                type_room: 'Family',
                date: '19/02/2025',
                start_time: '-',
                end_time: '-',
                duration: '00:00',
                done_by: 'Imus',
                remarks: 'lorem ipsum dolor sit amet',
                status_cleaning: '',
            },
            {
                no_room: 'A1',
                type_room: 'Studio',
                date: '19/02/2025',
                start_time: '-',
                end_time: '-',
                duration: '00:00',
                done_by: 'Arif',
                remarks: 'lorem ipsum dolor sit amet',
                status_cleaning: '',
            },
        ])
        const headers = ref([
            { key: 'no_room', label: 'Room Number', sortable: true},
            { key: 'type_room', label: 'Room Type', sortable: true},
            { key: 'date', label: 'Date', sortable: true},
            { key: 'start_time', label: 'Start Time', sortable: true},
            { key: 'end_time', label: 'End Time', sortable: true},
            { key: 'duration', label: 'Duration', sortable: true},
            { key: 'done_by', label: 'Done By', sortable: true},
            { key: 'remarks', label: 'Remarks', sortable: true},
            { key: 'action', label: 'Actions'},
        ])
        const customActions = ref([
        {
            label: 'Finish',
            variant: 'success',
            icon: 'fas fa-stopwatch',
            action: (item) => {
                modalTime.value = true
            console.log('Update action clicked for:', item);
            // Implement your Update logic here
            }
        }
        ])
        
        const statistics = ref([
          {
            label: 'Total',
            key: 'Today',
            value: 3,
            color: 'primary',
            icon: iconToday,
          },
          {
            label: 'Total',
            key: 'Week',
            value: 8,
            color: 'primary',
            icon: iconWeek,
          },
        ])

        return{
            data,
            headers,
            modal,
            modalTime,
            customActions,
            statistics
        }
    }

}
</script>

<style>

</style>